import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { projects } from "@/mocks/projects";

export default function ProjectsSection() {
  const [hovered, setHovered] = useState<number | null>(null);
  const navigate = useNavigate();
  const visible = projects.slice(0, 6);

  return (
    <section id="projeler" className="bg-[#F8F9FA] py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-12 gap-4">
          <div>
            <span className="text-[#4CAF50] text-sm font-semibold uppercase tracking-widest mb-2 block">
              Portföyümüz
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A2B4A]">
              Projeler
            </h2>
          </div>
          <button
            onClick={() => navigate('/projeler')}
            className="flex items-center gap-2 text-[#4CAF50] font-semibold text-sm hover:gap-3 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Tümünü Gör <i className="ri-arrow-right-line" />
          </button>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {visible.map((project) => (
            <div
              key={project.id}
              className="bg-white rounded-2xl overflow-hidden cursor-pointer group transition-all duration-300 hover:-translate-y-1.5 hover:shadow-lg"
              onMouseEnter={() => setHovered(project.id)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => navigate(`/projeler/${project.id}`)}
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Content */}
              <div className="p-5 flex items-start justify-between gap-3">
                <div>
                  <div className="text-xs text-[#4CAF50] font-semibold uppercase tracking-wide mb-1">
                    {project.category}
                  </div>
                  <h3 className="text-[#1A2B4A] font-bold text-base leading-snug mb-1">
                    {project.title}
                  </h3>
                  <div className="flex items-center gap-1 text-[#718096] text-xs">
                    <i className="ri-map-pin-line" />
                    {project.location}
                  </div>
                </div>
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full bg-[#4CAF50]/10 flex-shrink-0 transition-all duration-200 ${
                    hovered === project.id ? "bg-[#4CAF50] translate-x-1" : ""
                  }`}
                >
                  <i
                    className={`ri-arrow-right-line text-sm ${
                      hovered === project.id ? "text-white" : "text-[#4CAF50]"
                    }`}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Show all projects button */}
        <div className="text-center mt-10">
          <button
            onClick={() => navigate('/projeler')}
            className="inline-flex items-center gap-2 border-2 border-[#4CAF50] text-[#4CAF50] font-semibold px-8 py-3 rounded-full hover:bg-[#4CAF50] hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
          >
            Daha Fazla Proje Gör
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}
